import image from 'assets/images/shield.png';
import { Button } from 'components/Button/Button';
import { colors } from 'styles';
import { H2, H3 } from '../../styles/FontStyles';
import { Div } from '../../styles/Styles';

export const ThankYou = () => {
  return (
    <>
      <Div $flex $column $center>
        <H3 center color={colors.white} mb='40' mbSM='20'>
          Thank You For Your Purchase
        </H3>
        <img style={{ width: '100%', maxWidth: '260px' }} src={image} />
        <H2 center color={colors.white} mb='40' mbSM='40' mt='50' mtSM='20'>
          Order #123RGR231567Y Confirmed
        </H2>
        <Button>Track Order</Button>
      </Div>
    </>
  );
};
